import { ReactElement } from 'react';

import { FormattedMessage } from 'react-intl';

import { getNavigationItems } from './navigation-items';
import styles from './navigation.module.scss';

import { useUserData } from 'context';
import { NavigationLink } from 'views/components';

const Navigation = (): ReactElement => {
  const { user } = useUserData();

  const items = getNavigationItems(user?.role.name);

  return (
    <nav className={styles.navigation}>
      <ul className={styles.navigation__list}>
        {items.map(item => (
          <li key={item.path} className={styles.navigation__item}>
            <NavigationLink to={item.path}>
              <FormattedMessage id={item.titleId} />
            </NavigationLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};
export { Navigation };
